// extracted by mini-css-extract-plugin
export var root = "PlasmicList-module--root--x05IB";
export var freeBox = "PlasmicList-module--freeBox--YY-5J";
export var freeBoxglobal_mode_dark = "PlasmicList-module--freeBoxglobal_mode_dark--DeHnJ";
export var info = "PlasmicList-module--info--Fp87b";
export var infoIcon2 = "PlasmicList-module--infoIcon2--sPkqm";
export var link = "PlasmicList-module--link--7jtd-";
export var logo = "PlasmicList-module--logo--3rk8G";
export var modetoggle = "PlasmicList-module--modetoggle--j+LE8";
export var infoIcon = "PlasmicList-module--infoIcon--BURNT";
export var list = "PlasmicList-module--list--ycN2u";
export var li__kCL6 = "PlasmicList-module--li__kCL6--h9qSn";
export var img___3A9WI = "PlasmicList-module--img___3A9WI--3Ebdz";
export var __wab_imgSpacer = "PlasmicList-module--__wab_img-spacer--QVzXt";